import { createContext, useState, Dispatch, SetStateAction } from 'react'

interface INavbarContext {
  backInfo: {
    text: string
    link: string
    handleClick?: Function
  }
  setBackInfo: Dispatch<
    SetStateAction<{ text: string; link: string; handleClick?: Function }>
  >
}

const defValues: INavbarContext = {
  backInfo: {
    text: 'Back to Angle',
    link: 'https://anglehealth.com/network-directories'
  },
  setBackInfo: () => {}
}

export const NavbarContext = createContext(defValues)

export const NavbarProvider: React.FC = ({ children }) => {
  const [backInfo, setBackInfo] = useState({
    text: defValues.backInfo.text,
    link: defValues.backInfo.link
  })

  return (
    <NavbarContext.Provider value={{ backInfo, setBackInfo }}>
      {children}
    </NavbarContext.Provider>
  )
}
